import './style.scss'

import { saleEndDate } from '../../../js/components/SaleEndDate/SaleEndDate'
import { Timer } from '../../../js/components/Timer/Timer'
import {pushDSPCounter} from '../../../js/libs/pixel'
import { showOrderPopup } from '../../../js/components/popups'

export default !function () {
  const block = document.querySelector('.start-screen-v3')

  if (!block) {
    return
  }

  const button = block.querySelector('.start-screen-v3__button')

  if (button) {
    const siteArea = button.dataset.pixel

    button.addEventListener('click', (evt) => {
      evt.preventDefault()

      if (button.dataset.actionButton === 'order-modal') {
        const blockName = button.closest('[data-block-name]')?.dataset.blockName ?? 'Блок без названия'
        showOrderPopup(blockName)
      }

      siteArea && pushDSPCounter(siteArea)
      window.$analytics && window.$analytics.push('start-screen-btn-click')
    })

    if (window.innerWidth < 1279) {
      const blocksWithFooter = document.querySelectorAll('.footer')
      const blocksWithButton = document.querySelectorAll('.block:not(.start-screen-v3) .ui-button')
      const blocks = [...blocksWithButton, ...blocksWithFooter]
      const bar = document.querySelector('.start-screen-v3__bar')

      let visibleCount = 1

      const changeVisibleButton = (entries) => {
        entries.forEach(entry => {
          entry.isIntersecting ? ++visibleCount : --visibleCount
          visibleCount = visibleCount > 0 ? visibleCount : 0

          visibleCount
            ? bar.classList.add('start-screen-v3__bar--hidden')
            : bar.classList.remove('start-screen-v3__bar--hidden')
        })
      }

      const observer = new IntersectionObserver(changeVisibleButton, { rootMargin: '150px' })

      blocks.forEach(block => {
        observer.observe(block)
      })
    }
  }

  // init timer
  const timers = block.querySelectorAll('[data-type=timer]')

  timers.forEach((timerWrapper) => {
    saleEndDate
      .addObserver(time => new Timer({ time, timerWrapper }))
  });
}()
